var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative min-h-full w-full"},[_c('div',{staticClass:"container mx-auto p-16"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }